/**
 * Clerk Authentication Utilities
 */

/**
 * Wait for Clerk to load and return the current user
 * Useful in route loaders and beforeLoad hooks
 */
export const waitForClerk = async (maxAttempts = 50) => {
  for (let i = 0; i < maxAttempts; i++) {
    if (window.Clerk?.user !== undefined) {
      return window.Clerk.user;
    }
    await new Promise(resolve => setTimeout(resolve, 100));
  }
  return window.Clerk?.user;
};
